<template>
  <v-app :dark="isDark">
    <transition name="fade" mode="out-in" style="height: 100%">
      <router-view />
    </transition>
  </v-app>
</template>

<script>
import "./assets/effects.css";
import "./assets/forms.css";
import "./assets/tables.css";

export default {
  name: "App",
  data: () => ({
    isDark: true,
    inDark: ["login"]
  }),
  computed: {},
  created() {
    let firstPage = this.$route.name;
    this.initPage(firstPage);
  },
  watch: {
    $route(to) {
      this.initPage(to.name);
    }
  },
  methods: {
    initPage(pageName) {
      this.chooseTheme(pageName);
      this.$store.commit("error/RESET", {
        root: true
      });
      this.$store.commit("success/RESET", {
        root: true
      });
      this.$store.commit("confirm/RESET", {
        root: true
      });
    },
    chooseTheme(pageName) {
      if (this.inDark.includes(pageName)) {
        this.isDark = true;
      } else {
        this.isDark = false;
      }
    }
  }
};
</script>

<style>
:root {
  --primary: #17365d;
  --secondary: #2478b5;
  --accent: #17365d;
  --card-bg: #f0fafe;
  --border-clr: rgba(0, 0, 0, 0.12);
  --info: #17365d;
  --success: #92d050;
  --error: #9b0d0d;
  --warning: #dba90f;
  --readonly: #adaaaa;
}

.container.container--fluid {
  margin: 0 auto !important;
}
.main-back-arrow {
  font-size: 22px !important;
  color: var(--primary) !important;
}
.main-refresh-icon {
  font-size: 22px !important;
  color: var(--primary) !important;
}
.v-application--wrap {
  background-color: #ffffff !important;
}
.v-application--wrap > div {
  height: 100%;
}
.is-clickable:not(.disabled) {
  cursor: pointer;
}
.list-item {
  background-color: white !important;
}
.h28-light {
  font-size: 28px;
  font-weight: 300;
}
.h36-medium {
  font-size: 36px;
  font-weight: 500;
  margin-top: -16px;
}
.caption {
  line-height: initial;
}
.importantbutton {
  background-color: var(--primary) !important;
  color: white !important;
  font-weight: bold !important;
}
.card-text-color {
  color: rgba(0, 0, 0, 0.87) !important;
}
.secondimportantbutton {
  color: #ffffff !important;
  font-weight: bold !important;
}
.my-3 {
  margin-top: 20px !important;
  margin-bottom: 25px !important;
}
.height-spacer {
  min-height: 30px;
}
.v-toolbar__title.my-v-toolbar__title-inherit {
  white-space: inherit !important;
  overflow: inherit !important;
}
.my-button-toolbar .v-toolbar__content {
  padding-left: 0% !important;
}
.v-toolbar__content {
  padding: 10px 10px !important;
  margin-bottom: 4px !important;
}
.divider {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}
.theme--light.v-toolbar {
  background-color: rgba(51, 71, 91, 0.8);
  color: #ffffff;
}
.card-with-transparent-background {
  background-color: transparent !important;
  border-color: transparent !important;
  border: 0px !important;
}
/* START: Scrollbar style */
::-webkit-scrollbar {
  background: #b0bec5;
  width: 6px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
::-webkit-scrollbar-thumb {
  background-color: var(--primary);
}
/* END: Scrollbar style */
.date-picker >>> .v-date-picker-title__date,
.date-picker >>> .v-date-picker-header__value button {
  text-transform: capitalize;
}
/* START: applies custom styles to hf-portal tooltips */
.portal-tooltip.v-tooltip__content {
  background-color: var(--primary) !important;
  padding: 5px 16px !important;
  color: #ffffff !important;
  font-size: 15px !important;
  font-weight: bold !important;
  font-style: italic !important;
}
.portal-tooltip-inverted.v-tooltip__content {
  background-color: #ffffff !important;
  padding: 5px 16px !important;
  color: var(--primary) !important;
  font-size: 15px !important;
  font-weight: bold !important;
  font-style: italic !important;
}
/* END: applies custom styles to hf-portal tooltips */
.official-logo {
  width: 278px !important;
  height: 84px !important;
}
</style>
